import loadable from '@loadable/component'

export default {
    '/:type/my/deliverLogisticsList': loadable(() => import('./logistics/logisticsList')),
    '/:type/my/deliverLogisticsDetail': loadable(() => import('./logistics/logisticDetails')),
}